import * as React from 'react';

import { Root } from './styled';


export type NegativeMarginProps = {
	component?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
	value: number;
}

const NegativeMargin: React.SFC<NegativeMarginProps> = ({ component, ...rest }) => {
	return (
		<Root as={component} {...rest } />
	);
}

NegativeMargin.displayName = 'NegativeMargin';
NegativeMargin.defaultProps = {
	component: 'div',
	value: 0,
};

export default NegativeMargin;
